import React from 'react';
import { FormattedMessage } from 'react-intl';
import { EUROPE } from 'enums/regions';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import get from 'lodash/get';
import { getNeedCaseFileDownloadInfo } from 'utils/projectFiles';
import { toast } from 'react-toastify';
import axios from 'axios';

const API_URL = window.env.API_URL;
const ACCESS_TOKEN = window.env.ACCESS_TOKEN;
const toastConfig = { autoClose: 3000 };

const Project = ({ values }) => {
  const needCaseRaw = get(values, 'data.needCase', false);
  const needCase = needCaseRaw === true;
  const needCaseFile = getNeedCaseFileDownloadInfo(values.data);

  const isEuropeCountry = EUROPE.includes(values.data.country);

  // TODO: issue dd5b5f54-99ee-4b5d-8965-7e22733c2d12, this can unified in a hook or utils function
  const handleDownloadNeedCaseFile = async () => {
    if (!needCaseFile?.uuid) return;
    try {
      const endUserFileUrl = `${API_URL}/bulk/download-stream/${encodeURIComponent(
        needCaseFile.uuid,
      )}`;
      const response = await axios.get(endUserFileUrl, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
        },
        responseType: 'blob',
      });
      const fallbackName =
        needCaseFile.name ||
        (needCaseFile.key &&
          needCaseFile.key.split('/').filter(Boolean).pop()) ||
        'certificado';
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = fallbackName;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      toast.error(
        <FormattedMessage id="Hubo un error al descargar el archivo" />,
        toastConfig,
      );
    }
  };

  return (
    <div className="row">
      <div className="col-12 ViewOrEdit">
        <div>
          <strong>
            <FormattedMessage id="Nombre del proyecto:" />
          </strong>
          <span>{get(values, 'data.name', '-')}</span>
        </div>
        <div className="kt-space-20" />
        <div>
          <strong>
            <FormattedMessage id="Tipo de proyecto:" />
          </strong>
          <span>{get(values, 'data.type', '-')}</span>
        </div>
        <div className="kt-space-20" />
        <div>
          <strong>
            <FormattedMessage id="Provincia:" />
          </strong>
          <span>{get(values, 'data.state', '-')}</span>
        </div>
        <div className="kt-space-20" />
        <div>
          <strong>
            <FormattedMessage id="Código postal:" />
          </strong>
          <span>{get(values, 'data.postalCode', '-')}</span>
        </div>
        <div className="kt-space-20" />
        {isEuropeCountry && (
          <div>
            <strong>
              <FormattedMessage id="Case of Study:" />
            </strong>
            <span>
              {needCase ? (
                <FormattedMessage id="SI" />
              ) : (
                <FormattedMessage id="NO" />
              )}
            </span>
          </div>
        )}
        <div className="kt-space-20" />
        {isEuropeCountry && needCase && (
          <div>
            {needCaseFile?.uuid ? (
              <Button
                className="mr-2"
                variant="contained"
                color="primary"
                startIcon={<GetAppIcon />}
                onClick={handleDownloadNeedCaseFile}
              >
                <FormattedMessage id="Descargar certificado end user" />
              </Button>
            ) : (
              <FormattedMessage id="No hay certificado end user" />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Project;
